export { default } from "./BasesYCondiciones"